"use client";

import { Star } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";

interface StarRatingProps {
  value: number;
  onChange: (rating: number) => void;
}

export const StarRating = ({ value, onChange }: StarRatingProps) => {
  const [hovered, setHovered] = useState(0);
  const displayValue = hovered || value;
  const t = useI18n();

  const labels = [
    "",
    t("feedbackModal.starRating.poor"),
    t("feedbackModal.starRating.fair"),
    t("feedbackModal.starRating.good"),
    t("feedbackModal.starRating.great"),
    t("feedbackModal.starRating.amazing"),
  ];

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          className="cursor-pointer p-0.5 transition-transform hover:scale-110"
          onMouseEnter={() => setHovered(star)}
          onMouseLeave={() => setHovered(0)}
          onClick={() => onChange(star)}
        >
          <Star
            className={cn(
              "size-5 transition-colors",
              star <= displayValue
                ? "fill-yellow-400 text-yellow-400"
                : "text-muted-foreground",
            )}
          />
        </button>
      ))}
      {value > 0 && (
        <span className="ml-2 text-xs text-muted-foreground">
          {labels[value]}
        </span>
      )}
    </div>
  );
};
